import deviceSocketReducer from "./reducers";

export default deviceSocketReducer;